import React from "react";

// Styles
import classes from "./GenericErrorModal.module.scss";
import Button from "@overrides_venia/venia-ui/components/Button/index";
import { onlyIcon } from "@Components/Icon/icon";
import { useIntl } from "react-intl";
import Modal from "@Components/Modal/modal";
export const GenericErrorModal = _ref => {
  let {
    id,
    onClose,
    isOpen,
    title,
    info,
    buttonText
  } = _ref;
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(Modal, {
    id: id || "modal-book-table-genericError",
    position: "uk-position-center",
    modalDialogClass: "uk-border-rounded uk-height-large uk-text-center",
    animation: "uk-animation-scale-up",
    modalCloseOutside: true,
    classNameExtra: classes.GenericErrorModal_modal,
    isOpen: isOpen,
    onCloseButtonClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.GenericErrorModal_cont, " uk-border-rounded")
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-column uk-margin-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.iconCont
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(onlyIcon("icon-close"), " ").concat(classes.icon)
  })), /*#__PURE__*/React.createElement("h2", {
    className: "".concat(classes.title)
  }, title || formatMessage({
    id: "book.table.error3"
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.info)
  }, info || formatMessage({
    id: "book.table.error4"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.buttonCont)
  }, /*#__PURE__*/React.createElement(Button, {
    id: "genericErrorModal",
    color: "primary",
    fullScreen: true,
    height: "large",
    type: "button",
    onClick: onClose,
    extraClass: "uk-position-bottom"
  }, buttonText || formatMessage({
    id: "book.table.got.it"
  })))));
};